import React, { useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import banner from "../../../../assets/new-images/faq_option_A_personal-help.png";
import PageBanner from "../../../../common/components/PageBanner";
import "../../KnowldgeBase/styles/knowledge.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

const Faq = () => {
  const faqsData = [
    {
      question: "Why do I need an emergency action plan?",
      answer:
        "An emergency action plan is essential as it helps you and your family prepare for, respond to, and recover from emergencies or disasters by outlining specific steps and procedures to ensure everyone’s safety.",
      panel: "panel1",
    },
    {
      question:
        "Why do emergency management agencies throughout the world recommend that every family have an emergency/disaster response and preparedness plan? ",
      answer:
        "Emergency management agencies emphasize the importance of individual and family preparedness to enhance overall community resilience. By having an emergency plan, families can effectively respond to emergencies, reduce confusion, and know what to do.",
      panel: "panel2",
    },

    {
      question: "What should I include in my MYREDFOLDER® Family plan?",
      answer:
        "Some critical information to include in your MYREDFOLDER® Family plan includes important contact information, evacuation routes, designated meeting places, communication procedures, essential supplies, listed current medication, and specific actions to take during various emergency scenarios.",
      panel: "panel3",
    },

    {
      question: "How does having the MYREDFOLDER® plan benefit my family?",
      answer:
        "MYREDFOLDER® helps your household agree on the plan ahead of time: who checks on whom, where to meet, what to take, and where your records are. That can reduce confusion when routines break down.",
      panel: "panel4",
    },

    {
      question:
        "Is the MYREDFOLDER® Family plan customized for specific hazards? ",
      answer:
        "Yes. You can add the hazards relevant to your household and location, such as hurricanes, earthquakes, floods, or wildfires, and use the guides in our Disaster Resource Library to plan for them.",
      panel: "panel5",
    },
    {
      question: " How often should I update my MYREDFOLDER® Family plan?",
      answer:
        "It is recommended to review and update your emergency plan at least once a year or whenever there are significant changes in your family composition, contact information, or living situation.",
      panel: "panel6",
    },
    {
      question: "Are emergency plans only for natural disasters?",
      answer:
        "No, emergency plans are essential for all types of emergencies, including natural disasters, fires, medical emergencies, power outages, or civil disturbances. ",
      panel: "panel7",
    },
    {
      question: "What role does communication play in an emergency plan? ",
      answer:
        "Communication is crucial during emergencies. Your MYREDFOLDER® plan records meeting places and contacts, and the MYREDFOLDER app lets invited family members check in and message one another.",
      panel: "panel8",
    },
    {
      question: "How can an emergency plan help businesses? ",
      answer:
        "Businesses can benefit from the MYREDFOLDER® Family plan by providing an active means of safeguarding their employees, minimizing downtime, and maintaining continuity of operations during and after emergencies.",
      panel: "panel9",
    },
    {
      question: "What resources should I include in my emergency kit? ",
      answer:
        "Your emergency kit should include essential supplies such as water, non-perishable food, a first aid kit, flashlights, batteries, blankets, and any necessary medications.",
      panel: "panel10",
    },
    {
      question:
        "How can children be involved in the MYREDFOLDER®  planning process? ",
      answer:
        "Involving children in the planning process helps them understand the importance of preparedness. Assign them age-appropriate tasks and explain emergency procedures in a calm and reassuring manner.",
      panel: "panel11",
    },
    {
      question: "What steps should I take during an evacuation? ",
      answer:
        "Your MYREDFOLDER® Family plan should include evacuation routes and procedures. Follow the instructions of local authorities, bring your emergency kit, and ensure everyone in your family is accounted for.",
      panel: "panel12",
    },
    {
      question: "Can I rely solely on emergency services during an emergency?",
      answer:
        "Emergency services may be overwhelmed during a large-scale disaster. A family plan helps you know what to do while you wait for help, and you should always follow instructions from local authorities.",
      panel: "panel13",
    },
    {
      question: "How can neighbors help each other during emergencies?",
      answer:
        " Establishing a network of neighbors who can support each other during emergencies fosters community resilience. Share your emergency plans, communicate regularly, and offer assistance when needed.",
      panel: "panel14",
    },
    {
      question:
        " What are the key benefits of having the MYREDFOLDER® plan for my family?",
      answer:
        "A shared plan keeps your contacts, meeting places, records, and property details together, and helps everyone in your household know their role.",
      panel: "panel15",
    },
  ];

  // New questions from the refresh. Answers must match live behavior, so any
  // question with answer: null stays hidden until MYREDFOLDER, Inc. supplies it.
  // TODO(refresh): billing/product answers pending business sign-off.
  const refreshFaqs = [
    { question: "What is included in Premium?", answer: null, panel: "premium" },
    { question: "How does the trial work?", answer: null, panel: "trial" },
    { question: "Who can access my family information?", answer: null, panel: "access" },
    { question: "How do I cancel?", answer: null, panel: "cancel" },
    {
      question: "What roles do MYREDFOLDER, Inc. and NEPTA play?",
      answer:
        "MYREDFOLDER, Inc. offers the program, and the National Emergency Planning and Training Association (NEPTA) administers it, supporting training, outreach, and rollout.",
      panel: "roles",
    },
  ];
  const visibleFaqs = [...refreshFaqs, ...faqsData].filter((faq) => faq.answer);

  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <div>
      <Grid>
        <PageBanner
          image={banner}
          alt="A smiling woman on the phone while using a laptop at her kitchen table."
          eyebrow="Knowledge Base / FAQ"
          title="Frequently Asked Questions"
        />
        <Grid container sx={{ background: "#FAFAFB" }}>
          <div className="faq-header-container">
            <Grid container spacing={1} >
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                sx={{ marginBottom: "60px" }}
              >
                {visibleFaqs.map((faq, index) => (
                  <Accordion
                    elevation={0}
                    key={faq.panel}
                    expanded={expanded === faq.panel}
                    onChange={handleChange(faq.panel)}
                    sx={{
                      marginTop: "15px",
                      borderLeft: expanded === faq.panel ? "" : '3px solid #ff3535',
                      backgroundColor: "white",
                      "&:before": { display: "none" },
                      "&:hover": {
                        boxShadow: "0px 2px 8px #00000033",
                      },
                      "&.Mui-expanded": {
                        marginTop: "15px",
                        borderBottom: "1px solid #ff3535",
                        borderLeft: "3px solid #ff3535"
                      },
                    }}
                  >
                    <AccordionSummary
                      aria-controls={`faq-${faq.panel}-content`}
                      id={`faq-${faq.panel}-header`}
                      sx={{
                        cursor: "pointer",
                        px: 2,
                        minHeight: "64px !important",
                        maxHeight: "none !important",
                        "& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded": { m: "16px 0 !important" },
                        "& .MuiAccordionSummary-expandIconWrapper": { flexShrink: 0, transform: "none !important" },
                      }}
                      expandIcon={
                        expanded === faq.panel ? (
                          <Box component="span" aria-hidden="true"
                            sx={{
                              backgroundColor: '#ff3535 !important', borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                              width: '20px',
                              height: '20px',
                              overflow: 'hidden',
                              flexShrink: 0,
                              mr: 0,
                              ml: '20px'
                            }}
                          >
                            <RemoveIcon sx={{ color: 'white', fontSize: 16 }} />
                          </Box>
                        ) : (
                          <Box component="span" aria-hidden="true"
                            sx={{
                              backgroundColor: '#ff3535 !important', borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                              width: '20px',
                              height: '20px',
                              overflow: 'hidden',
                              flexShrink: 0,
                              mr: 0,
                              ml: '20px'
                            }}
                          >
                            <AddIcon sx={{ color: 'white', fontSize: 16 }} />
                          </Box>
                        )
                      }
                    >
                      <Typography component="h2" className="primary-font-bold1" sx={{ paddingRight: '12px' }}>{faq.question.trim()}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ borderTop: '1px solid #00000033', padding: '16px 24px 20px !important' }}>
                      <Typography className="primary-font-normal-9">{faq.answer.trim()}</Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default Faq;
